<template>

    <tr @click="info" v-if="registration.team && registration.team.name" class="w-full -mx-10 text-main-text md:border-b"
        :class="[ type === 'reserve' ? 'bg-reserved': '', searched? 'bg-brand-pink-light':'' ]"
        >
        <td v-if="mobile" class="w-5">
          <img class="absolute" style="transform:translateY(-8px)" v-if="registration.play_for_first_time" src="@/assets/SVG/new_team.svg" alt="">
            <img class="" v-if="registration.has_another_application" src="@/assets/SVG/exclimation-mark.svg" alt="">
        </td>

         <td v-else class="pl-5 p-0 relative">
            <img class=" absolute" style="left: 6px; top:36%" v-if="registration.play_for_first_time" src="@/assets/SVG/new_team.svg" alt="">
            <img class="w-3 h-3 block" v-if="registration.has_another_application" src="@/assets/SVG/exclimation-mark.svg" alt="">
        </td>

        <td v-if="!mobile" class="w-3"   >
           <div  class="flex justify-end items-start mr-3 my-3">
            <label class="flex" >
                <span class="">
                    <input class="checkbox" @click.prevent="addSelect" :checked="isChecked"  type="checkbox">
                    <span class="checkbox-custom" :class="isChecked? 'checkedBut' : ''"></span>
                </span>
            </label>
          </div>
        </td>

        <td>
            {{team_position}}
        </td>
        <td @mousedown="overflowTumbler" @mouseup="overflowTumbler" @mouseout="endOverflow" class="max-w-2xxs truncate whitespace-no-wrap" field="canAbs">
            <span :class="isSearched('name')? 'bg-brand-pink-light':''">{{registration.team.name}}</span>
        </td>
         <td  v-if="!mobile" class="relative">
           <div class="flex flex-row">
             <p class="lg:w-1/2">{{(registration.total_cost - registration.paid_total)}} {{currencySign}}</p>
             <img v-if="registration.promocode_discount" @mouseover="switchPopper" @mouseleave="switchPopper" class="ml-1 z-10" src="@/assets/SVG/discount.svg" alt="" ref="discount">
           </div>
           <div class="absolute rounded-sm shadow-md p-2 bg-white mt-2 w-68" style="transform: translateX(2.5rem); z-index: 100;border: 0.5px solid #DADADA;" v-if="show_discount_popper" ref="elements">
             <p>Команда применила промокод <span class="font-bold">{{registration.promocode}}</span> на скидку -{{registration.promocode_discount}}%</p>
           </div>
        </td>
        <td class="text-center font-bold md:font-normal md:text-left">
            {{registration.player_count}}
        </td>

        <!--<td v-if="!mobile&&event.game_type.toLowerCase().includes('корпоративн')"><div><img class="w-4 h-4" src="@/assets/SVG/galochka.svg"></div></td>-->
        <td v-if="!mobile&&isCorpLeague">
          <div v-if="haveLogo">
            <img class="w-4 h-4" src="@/assets/SVG/galochka.svg">
          </div>
          <div v-else class="w-4 h-4">
          </div>
        </td>

        <td v-if="!mobile&&!isCorpLeague" class="flex justify-start items-center relative h-full">
          <on-click-outside :do="hideComment">
          <img v-if="registration.comment" src="@/assets/SVG/have-comment.svg" class="h-5 w-5 mt-1 cursor-pointer" @click="onCommentClick">
          <img v-else src="@/assets/SVG/no-comment.svg" class="h-5 w-5 mt-1">
          </on-click-outside>
          <div v-if="showComment" v-text="registration.comment" class="p-4 bg-white min-w-50 border border-main-text absolute pin-t pin-r mt-10 mr-6 z-20">Здесь будет комментарий, который указан в модалке во время регистрации </div>
        </td>

        <td v-if="!mobile">
          <div class="flex justify-start items-center relative h-full">
            <on-click-outside :do="hideDotesMenu">
              <img src="@/assets/SVG/dotes-menu.svg" class="h-6 w-6 cursor-pointer" :class="dotes_menu_active? 'dotes-menu-active' : 'dotes-menu'"
                @click="dotes_menu_active = !dotes_menu_active">
            </on-click-outside>
            <div v-if="dotes_menu_active"
              class="bg-white shadow-mozgo-2 rounded-lg absolute pin-t pin-r mt-10 z-20 whitespace-no-wrap">
              <p @click="team_description_modal=true" class="cursor-pointer rounded-lg px-4 hover:bg-brand-light hover:text-white py-2">Узнать подробнее </p>
              <p v-if="isCorpLeague" @click="downloadAllTeamLogos" class="cursor-pointer rounded-lg py-2 px-4 hover:bg-brand-light hover:text-white">Выгрузить все логотипы команды</p>
            </div>
          </div>
        </td>
        <team-description-modal  v-if="team_description_modal"
                              :team='registration'
                              :isCorpLeague="isCorpLeague"
                              :downloadImages ="downloadImages"
                              @close="team_description_modal=false">
        </team-description-modal>
    </tr>
</template>

<script>
import OnClickOutside from '@/views/OnClickOutside';
import TeamDescriptionModal from '../team-description-modal';
import Popper from 'popper.js';
import { mapState } from 'vuex';

export default {
  name: 'registration-line',
  props: ['registration', 'type', 'team_count', 'team_number', 'checkedLine', 'events', 'event', 'downloadImages'],
  components: { OnClickOutside, TeamDescriptionModal },
  data() {
    return {
      agree: false,
      checked: false,
      showComment: false,
      dotes_menu_active: false,
      team_description_modal: false,
      show_discount_popper: false,
    };
  },

  mounted() {
    // тут проходим по всей строке и выставляем поинтеры
    const elem = this.$el;
    [...elem.children].forEach((element) => {
      if ((element.scrollWidth > element.clientWidth) && element.getAttribute('field') === 'canAbs') {
        element.classList.toggle('cursor-pointer');
      }
    });
  },
  computed: {
    mobile() {
      return window.innerWidth < 840;
    },
    ...mapState({
      currency: state => state.auth.user.currency,
    }),

    currencySign() {
      return this.currency === 'RUB' ? '₽' : '';
    },
    isPossible() {
      if (!this.checkedLine[0].status) {
        this.checked = false;
      }
      if (this.checkedLine[0].status !== this.type && this.checkedLine[0].status) {
        this.checked = true;
      }
      return this.checked;
    },
    team_position() {
      return this.team_number + 1;
    },
    isChecked() {
      return this.checkedLine[0].ids.includes(this.registration.id);
    },

    searched() {
      if (!this.$route.query.like) return false;
      return !!this.registration.team.name.toLowerCase().includes(this.$route.query.like.toLowerCase());
    },

    isCorpLeague() {
      return this.event.game_type.toLowerCase().includes('корпоративная лига');
    },

    haveLogo() {
      if (!this.isCorpLeague) return false;
      const vals = Object.values(this.registration.team.company.media);
      return vals.length > 0;
    },
    totalCost() {
      return this.registration.total_cost;
    },

  },
  watch: {
    beforeDestroy() {
      if (this.popper) {
        this.popper.destroy();
      }
    },
  },
  methods: {
    downloadAllTeamLogos() {
      const files = Object.keys(this.registration.team.company.media);
      this.downloadImages(files);
    },
    info() {
      if (this.mobile) {
        this.$router.push({
          name: 'info',
          params: {
            team: this.registration.team.name,
            teamObject: this.registration.team,
            registrationId: this.registration.id,
            playerCount: this.registration.player_count,
            totalCost: this.totalCost,
            comment: this.registration.comment,
            creator: this.registration.creator,
            promocode_discount: this.registration.promocode_discount,
            event: this.event,
            type: 'registration',
            regType: this.type,
          },
        });
      }
    },
    onCommentClick() {
      this.showComment = !this.showComment;
    },

    hideComment() {
      this.showComment = false;
    },
    hideDotesMenu() {
      this.dotes_menu_active = false;
    },
    bus() {
      if (!this.checked) {
        if (!this.agree) {
          this.$emit('addSelectedLine', this.registration.id, true, this.type);
        }
        if (this.agree) {
          this.$emit('addSelectedLine', this.registration.id, false, this.type);
        }
      }
    },
    addSelect() {
      this.agree = !this.agree;
      this.bus();
    },

    overflowTumbler(event) {
      console.dir(event);
      const target = event.target.parentElement;
      const isOverflow = target.scrollWidth > target.clientWidth;
      if (target.getAttribute('field') === 'canAbs' && (isOverflow || target.classList.contains('exp'))) {
        if ((event.type === 'mouseup') && isOverflow) return;
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },
    endOverflow(event) {
      const target = event.target.parentElement;
      const isOverflow = target.scrollWidth > target.clientWidth;
      if (target.getAttribute('field') === 'canAbs' && (target.classList.contains('exp'))) {
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },
    uncheck() {
      this.agree = false;
    },
    isSearched(field) {
      if (!this.$route.query.like) return false;
      const fieldNamesArray = field.split('.');
      const rootObj = this.registration.team;
      const lastObj = fieldNamesArray.reduce((acc, field) => acc[field], rootObj);
      console.dir(lastObj);
      if (!lastObj) return false;

      return !!lastObj.toLowerCase().includes(this.$route.query.like.toLowerCase());
    },
    switchPopper() {
      this.show_discount_popper = !this.show_discount_popper;
      if (this.show_discount_popper) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.discount, this.$refs.elements, {
          placement: 'bottom-end',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
  },

};
</script>

<style scoped>

    .checkbox {
        display: none;
    }

    .checkbox-custom {
        position: relative;
        width: 16px;
        height: 16px;
        border: 1px solid #979797;
        border-radius: 2px;

    }

    .checkbox-custom,
    .label {
        display: inline-block;
        vertical-align: middle;
    }

    .checkedBut::before {
        content: "";
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 92%;
        height: 92%;
        background-color: #bd006c;
        border-radius: 1px;
        border: 1px solid white;
    }
    .fit_content {
      max-width: fit-content !important;
    }
    tr {
        @apply text-left text-sm;
    }

    .bg-reserved {
      background: rgba(255, 206, 66, 0.3);
    }

    .dotes-menu {
      border-radius: 999px;
      transition: background-color 0.5s linear;
    }

    .dotes-menu-active {
      background-color: #DADADA;
      border-radius: 999px;
    }
  @media (max-width: 840px) {
     td {
     line-height: 30px;
   }
  }


</style>
